<template>
  <div class="about-menu">
    <button
      type="button"
      class="about-menu__mobile-trigger"
      aria-haspopup="dialog"
      :aria-expanded="isMobileMenuOpen"
      @click="openMobileMenu"
    >
      <span class="about-menu__mobile-trigger-title">{{ MOBILE_TRIGGER_TEXT }}</span>
      <span class="about-menu__mobile-trigger-icon" aria-hidden="true">
        <ChevronIcon />
      </span>
    </button>

    <aside class="about-menu__desktop">
      <AboutMenuNav class="about-menu__nav" :items="visibleItems" />
    </aside>

    <UiModal
      title="Документы"
      :is-shown="isMobileMenuOpen"
      :teleport-target="shadowRoot"
      :size="UiModalSize.RESPONSIVE"
      :is-footer-hidden="true"
      @close="closeMobileMenu"
    >
      <template #content>
        <AboutMenuNav class="about-menu__mobile-nav" :items="visibleItems" @select="closeMobileMenu" />
      </template>
    </UiModal>
  </div>
</template>

<script setup lang="ts">
import { UiModal, UiModalSize } from '@experience/core-modal-ui';
import { computed, ref, watch, inject } from 'vue';

import type { AboutMenuItem } from '@/entities/about/model/types';
import ChevronIcon from '@/shared/ui/icons/ChevronIcon.vue';

import AboutMenuNav from './AboutMenuNav.vue';

const MOBILE_TRIGGER_TEXT = 'Все документы';

interface Props {
  activeSlug: string;
  items: AboutMenuItem[];
}

const props = defineProps<Props>();
const isMobileMenuOpen = ref(false);
const shadowRoot = inject<HTMLElement>('shadowRoot');

const visibleItems = computed(() =>
  props.items
    .filter((item) => !item.hidden)
    .map((item) => ({
      ...item,
      isActive: item.id === props.activeSlug,
    })),
);

function openMobileMenu() {
  isMobileMenuOpen.value = true;
}

function closeMobileMenu() {
  isMobileMenuOpen.value = false;
}

watch(
  () => props.activeSlug,
  () => {
    closeMobileMenu();
  },
);
</script>

<style scoped lang="scss">
.about-menu {
  width: 100%;
}

.about-menu__mobile-trigger {
  display: none;

  @include adaptivity.tablet {
    display: flex;
    gap: var(--alias-space-8);
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--alias-space-12) 0;
    color: var(--alias-color-text-default);
    text-align: left;
    background: var(--alias-color-background-default);
    border: 0;
  }
}

.about-menu__mobile-trigger-title {
  @include typography.base-400-400-medium;
}

.about-menu__mobile-trigger-icon {
  display: inline-flex;
}

.about-menu__desktop {
  @include adaptivity.tablet {
    display: none;
  }
}

.about-menu__nav {
  width: 100%;
}
</style>
